import SmallBadge from "./assets/smallBadge"
import HendyAmpsLogo from './assets/HendyAmpsLogo-Black.png'
import TubeGuy from './assets/tubeGuy.jsx';
import SmallTubeGuy from './assets/smallTubeGuy.jsx';
import BadgeWhite from './assets/badgeWhite.jsx';
import DialGraphic from "./assets/dialGraphic.jsx";



function AnalogStageModel() {
    return (
        <div style={{
            display: 'flex',
        

        }}>
            <div style={{
                backgroundColor: 'black',
                width: '400px',
                height: '90px',
                display: 'flex',
                flexDirection: 'row',
                
                borderRadius: '2px'
            }}>
                
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                }}>
                    <div style={{
                        backgroundColor: '#fbfbf3',
                        width: '14px',
                        height: '8px',
                        borderRadius: '4px',
                        position: 'absolute',
                        marginLeft: '4px',
                        marginTop: '4px'
                    }}>

                    </div>

                    <div style={{
                        backgroundColor: '#fbfbf3',
                        width: '14px',
                        height: '8px',
                        borderRadius: '4px',
                        position: 'absolute',
                        marginLeft: '4px',
                        marginTop: '78px'
                    }}>

                    </div>
                </div>
                <div style={{
                    width: '10px',
                    height: '10px',
                    backgroundColor: 'silver',
                    borderRadius: '50%',
                    position: 'absolute',
                    marginLeft: '35px',
                    marginTop: '40px',
                    border: '.5px solid black'
                }}>
                    <div style={{
                        backgroundColor: 'silver',
                        width: '2px',
                        height: '10px',
                        borderRadius: '5px',
                        position: 'absolute',
                        marginTop: '-5px',
                        marginLeft: '3.5px',
                        border: '.5px solid black'

                    }}>

                    </div>
                </div>
               
                   
                    

                  
                    <div style={{
                        width: '60px',
                        height: '60px',
                        position: 'absolute',
                        marginLeft: '53px',
                        marginTop: '19px'
                    }}>
                    <DialGraphic />
                    </div>
                <div style={{
                    backgroundColor: '#414243',
                    width: '35px',
                    height: '35px',
                    position: 'absolute',
                    borderRadius: '50%',
                    marginLeft: '60px',
                    marginTop: '28px'
                }}>
                    <div style={{
                        backgroundColor: 'white',
                        width: '10px',
                        height: '1.5px',
                        position: 'absolute',
                        marginLeft: '20.5px',
                        marginTop: '25.5px',
                        transform: 'rotate(45deg)'
                    }}>

                    </div>
                </div>

                <div style={{
                        backgroundColor: '#414243',
                        width: '15px',
                        height: '15px',
                        position: 'absolute',
                        borderRadius: '50%',
                        marginTop: '38px',
                        marginLeft: '115px'
                    }}>
                        <div style={{
                        backgroundColor: 'white',
                        width: '5px',
                        height: '1.5px',
                        position: 'absolute',
                        marginLeft: '8px',
                        marginTop: '10px',
                        transform: 'rotate(45deg)'
                    }}>

                    </div>
                    </div>

                    <div style={{
                        backgroundColor: '#414243',
                        width: '15px',
                        height: '15px',
                        position: 'absolute',
                        borderRadius: '50%',
                        marginTop: '38px',
                        marginLeft: '145px'
                    }}>
                        <div style={{
                        backgroundColor: 'white',
                        width: '5px',
                        height: '1.5px',
                        position: 'absolute',
                        marginLeft: '8px',
                        marginTop: '10px',
                        transform: 'rotate(45deg)'
                    }}>

                    </div>
                    </div>

                    <div style={{
                        width: '60px',
                        height: '60px',
                        position: 'absolute',
                        marginLeft: '173px',
                        marginTop: '19px'
                    }}>
                    <DialGraphic />
                    </div>

                <div style={{
                    backgroundColor: '#414243',
                    width: '35px',
                    height: '35px',
                    position: 'absolute',
                    borderRadius: '50%',
                    marginLeft: '180px',
                    marginTop: '28px'
                }}>
                    <div style={{
                        backgroundColor: 'white',
                        width: '10px',
                        height: '1.5px',
                        position: 'absolute',
                        marginLeft: '20.5px',
                        marginTop: '25.5px',
                        transform: 'rotate(45deg)'
                    }}>

                    </div>
                </div>

                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    marginLeft: '230px',
                    position: 'absolute'
                }}>

                    <div style={{
                        backgroundColor: '#414243',
                        width: '15px',
                        height: '15px',
                        position: 'absolute',
                        borderRadius: '50%',
                        marginTop: '20px'
                    }}>
                        <div style={{
                        backgroundColor: 'white',
                        width: '5px',
                        height: '1.5px',
                        position: 'absolute',
                        marginLeft: '8px',
                        marginTop: '10px',
                        transform: 'rotate(45deg)'
                    }}>

                    </div>
                    </div>

                    <div style={{
                        backgroundColor: '#414243',
                        width: '15px',
                        height: '15px',
                        position: 'absolute',
                        borderRadius: '50%',
                        marginTop: '55px'
                    }}>
                        <div style={{
                        backgroundColor: 'white',
                        width: '5px',
                        height: '1.5px',
                        position: 'absolute',
                        marginLeft: '8px',
                        marginTop: '10px',
                        transform: 'rotate(45deg)'
                    }}>

                    </div>
                    </div>
                </div>

                <div style={{
                marginLeft: '252px',
                marginTop: '-10px',
                position: 'absolute'
                }}>
                <BadgeWhite />
                </div>

                
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    marginLeft: '360px',
                    position: 'absolute'
                }}>
                    <div style={{
                        width: '20px',
                        height: '20px',
                        backgroundColor: 'silver',
                        borderRadius: '50%',
                        position: 'absolute',
                        
                        marginTop: '15px'
                    }}>
                        
                    </div>
                    <div style={{
                        width: '17px',
                        height: '17px',
                        backgroundColor: 'white',
                        borderRadius: '50%',
                        position: 'absolute',
                        marginLeft: '1.5px',
                        marginTop: '16.5px',
                        boxShadow: '0px 0px 10px white'
                        }}>

                        </div>

                    <div style={{
                        width: '15px',
                    height: '15px',
                    backgroundColor: 'silver',
                    borderRadius: '50%',
                    position: 'absolute',
                    marginLeft: '1.5px',
                    marginTop: '55px',
                    border: '.5px solid black'
                    }}>
                        <div style={{
                        backgroundColor: 'silver',
                        width: '3.5px',
                        height: '15px',
                        borderRadius: '5px',
                        position: 'absolute',
                        marginTop: '-6.5px',
                        marginLeft: '5.5px',
                        border: '.5px solid black'

                    }}>

                    </div>
                    </div>
                </div>

                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    marginLeft: '368px'
                }}>
                    <div style={{
                        backgroundColor: '#fbfbf3',
                        width: '14px',
                        height: '8px',
                        borderRadius: '4px',
                        position: 'absolute',
                        marginLeft: '4px',
                        marginTop: '4px'
                    }}>

                    </div>

                    <div style={{
                        backgroundColor: '#fbfbf3',
                        width: '14px',
                        height: '8px',
                        borderRadius: '4px',
                        position: 'absolute',
                        marginLeft: '4px',
                        marginTop: '78px'
                    }}>

                    </div>
                </div>

            </div>
        </div>
    )
}

export default AnalogStageModel